<div class="table-responsive">
  <!-- <button mat-raised-button class="createButton" color="accent" (click)="createCategory()">Kategorie erstellen</button> -->
  <table mat-table [dataSource]="tenants" class="mat-elevation-z8">
    <!-- Columns for Order interface -->
    <ng-container matColumnDef="guid">
      <th mat-header-cell *matHeaderCellDef>GUID</th>
      <td mat-cell *matCellDef="let tenant">{{ tenant.guid }}</td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Name</th>
      <td mat-cell *matCellDef="let tenant">{{ tenant.name }}</td>
    </ng-container>

    <ng-container matColumnDef="deleteOrders">
      <th mat-header-cell *matHeaderCellDef>Bestellungen löschen</th>
      <td mat-cell *matCellDef="let tenant">
        <button mat-icon-button (click)="deleteTenantOrders(tenant)">
          <mat-icon>delete_sweep</mat-icon>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="delete">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let tenant">
        <button mat-icon-button (click)="deleteTenant(tenant)">
          <mat-icon>delete</mat-icon>
        </button>
      </td>
    </ng-container>

    <!-- Define the displayed columns order -->
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let tenant; columns: displayedColumns;"></tr>
  </table>
</div>
